module.exports = __webpack_public_path__ + "static/media/test_loading_loop_ie.cef34d85.png";